import { HomeComponent } from './home/home.component';
import { SelectThirdComponent } from './select-third/select-third.component';
import { SelectLicenseComponent } from './select-license/select-license.component';
import { ResultComponent } from './result/result.component';
import { FormComponent } from './form/form.component';
import { RouteWithGuardData } from '@/auth/interface/auth.interface';
import { AuthGuard } from '@/auth/guard/auth.guard';

export const ExtendChildRoutes: RouteWithGuardData[] = [
  {
    path: 'third/select',
    component: SelectThirdComponent,
    canActivate: [AuthGuard],
    data: {
      requiredPrivilegesOr: [
        'LICENSE EXTEND THIRD_CONTRACTOR',
        'LICENSE EXTEND THIRD_EMPLOYEE',
      ],
    },
  },
  {
    path: 'select-license',
    component: SelectLicenseComponent,
    canActivate: [AuthGuard],
    data: {
      requiredPrivilegesOr: [
        'LICENSE EXTEND PERSONAL_CONTRACTOR',
        'LICENSE EXTEND PERSONAL_EMPLOYEE',
      ],
    },
  },
  {
    path: 'select-license/:ofuscatedData',
    component: SelectLicenseComponent,
    canActivate: [AuthGuard],
    data: {
      requiredPrivilegesOr: [
        'LICENSE EXTEND THIRD_CONTRACTOR',
        'LICENSE EXTEND THIRD_EMPLOYEE',
      ],
    },
  },
  {
    path: 'form',
    component: FormComponent,
    canActivate: [AuthGuard],
    data: {
      requiredPrivilegesOr: [
        'LICENSE EXTEND THIRD_CONTRACTOR',
        'LICENSE EXTEND THIRD_EMPLOYEE',
        'LICENSE EXTEND PERSONAL_CONTRACTOR',
        'LICENSE EXTEND PERSONAL_EMPLOYEE',
      ],
    },
  },
  {
    path: 'result/:ofuscatedData',
    component: ResultComponent,
    canActivate: [AuthGuard],
    data: {
      requiredPrivilegesOr: [
        'LICENSE EXTEND THIRD_CONTRACTOR',
        'LICENSE EXTEND THIRD_EMPLOYEE',
        'LICENSE EXTEND PERSONAL_CONTRACTOR',
        'LICENSE EXTEND PERSONAL_EMPLOYEE',
      ],
    },
  },
  {
    path: '', // child route path
    component: HomeComponent, // child route component that the router renders
  },
];
